import * as React from 'react'
import * as ReactDOM from 'react-dom'

function withOutsideClick(WrappedComponent) {
  return class extends React.Component<any, any> {
    references: {
      wrappedComponent: any
    } = {
      wrappedComponent: null
    }

    componentDidMount () {
      setTimeout(() => {
        document.addEventListener('click', this.onWindowClick)
        document.addEventListener('touchstart', this.onWindowClick)
      }, 0)
    }

    componentWillUnmount() {
      document.removeEventListener('click', this.onWindowClick)
      document.removeEventListener('touchstart', this.onWindowClick)
    }

    onWindowClick = (event) => {
      const domNode = ReactDOM.findDOMNode(this.references.wrappedComponent)
      if (domNode && !domNode.contains(event.target)) {
        this.props.handleClickOutside && this.props.handleClickOutside()
      }
    }

    render () {
      const { handleClickOutside, ...passThroughProps } = this.props
      return <WrappedComponent {...passThroughProps} ref={(node) => this.references.wrappedComponent = node} />
    }
  }
}

export {
  withOutsideClick
}